import { useState, useMemo, useEffect, useContext } from 'react';
import Page from '../../../views/page/PreviewCurrentPage/PreviewCurrentPage';
import UserContext from '../../../common/utils/getContext';
import moment from 'moment';
import { getDefaultStaticProps, getLangPaths } from '../../api/_props';
import { useRouter } from 'next/router';
import Loader from '../../../widgets/plug/Loader/Loader';
import { getUserRoles } from '../../../common/utils/memo';
import { navigateV2, getData, replaceUrl } from '../../../common/utils/router';
import { getPageConnect, getPagesConnect } from '../../../common/utils/api';
const project = require('../../../scripts/configs/project');

const PreviewPage = ({ data = {}, translates }) => {
    const { storageLoaded, userToken, lang, time } = useContext(UserContext);

    const notInTime = useMemo(() => moment(data?.data?.date) > time(), [time, data]);

    const [allow, setAllow] = useState(data?.data?.status && !notInTime && data?.data?.visibility?.publish !== undefined);
    const [admin, setAdmin] = useState(false);

    useEffect(() => {
        if (allow) return;
        if (storageLoaded) {
            (async () => {
                const rolesRes = userToken ? await getUserRoles(userToken, lang) : {};
                const roles = rolesRes?.data || [];
                if (data?.data) {
                    if (roles?.some((user) => user.name === 'superadmin')) {
                        setAllow(true);
                        setAdmin(() => () => {
                            navigateV2('/admin/pagemanagement/edit/' + data?.data?.['_id']);
                        });
                    } else {
                        if (!data?.data?.status || notInTime) {
                            navigateV2('/error/404');
                        } else if (!!data?.data?.visibility?.rank || !!data?.data?.visibility?.packages) {
                            if (!userToken) {
                                navigateV2('/error/403');
                            } else {
                                const userData = await getData('/api/v1/user/marketing/profile', userToken, lang);
                                if (
                                    data?.data?.visibility?.rank.some((el) => el.id === userData.rank.id) ||
                                    data?.data?.visibility?.packages.some((el) => el.id === userData.package.id)
                                ) {
                                    setAllow(true);
                                } else {
                                    navigateV2('/error/403');
                                }
                            }
                        } else if (!!data?.data?.visibility?.roles) {
                            if (!userToken) {
                                navigateV2('/error/403');
                            } else {
                                if (
                                    data?.data?.visibility?.roles?.some(
                                        (r) => roles && roles.find((u) => u.name === r.name || u.name === 'superadmin')
                                    )
                                ) {
                                    setAllow(true);
                                } else {
                                    navigateV2('/error/403');
                                }
                            }
                        } else {
                            setAllow(true);
                        }
                    }
                }
            })();
        }
    }, [storageLoaded, userToken, data?.data, allow, lang, notInTime]);

    const seoData = useMemo(
        () => ({
            seo_title: data?.data?.seo?.metaTitle?.hasOwnProperty(lang)
                ? data?.data?.seo?.metaTitle?.[lang]
                : (typeof data?.data?.seo?.metaTitle === 'string'
                      ? data?.data?.seo?.metaTitle
                      : data?.data?.seo?.metaTitle?.default) ||
                  data?.data?.name ||
                  data?.data?.title[lang] ||
                  data?.data?.title?.default,
            seo_description: data?.data?.seo?.metaDescription,
            seo_keywords: data?.data?.seo?.metaKeywords
        }),
        [data?.data, lang]
    );
    const router = useRouter();
    const replacedUrl = useMemo(() => {
        return replaceUrl(data?.data?.url, router);
    }, [data?.data?.url, router]);

    if (!allow) return <Loader />;

    return (
        <>
            <Page
                canonical={replacedUrl}
                seoData={seoData}
                hideButtons={true}
                admin={admin}
                translates={translates}
                content={data?.data}
            />
        </>
    );
};
export async function getStaticProps({ params }) {
    const data = await getPageConnect({ url: params?.page });

    if (!data?.data) {
        return { notFound: true };
    }
    const lang = params?.lang;
    const isOffice = data?.data?.template === 'templatecabinet';
    const defaultProps = await getDefaultStaticProps(lang, `/page/${params?.page}`, [isOffice ? '/office' : '/', '/page']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    return {
        props: {
            ...defaultProps?.props,
            data,
            ...(isOffice ? { protect: 'office' } : {})
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = [];
    const langs = await getLangPaths();
    const pages = await getPagesConnect({ status: true });
    langs.forEach((lang) => {
        pages?.data?.forEach((page) => {
            paths.push({
                ...lang,
                params: { ...lang.params, page: page?.url }
            });
        });
    });
    return {
        paths,
        fallback: true
    };
}
export default PreviewPage;
